import { gql } from 'graphql-request';

export const TASK_TEMPLATE_FIELDS = gql`
  fragment TaskTemplateFields on TaskTemplateDto {
    templateId
    name
    description
    tasks
    organizationId
    createdAt
  }
`;

export const getTaskTemplates = gql`
  query getTaskTemplates {
    getTaskTemplates {
      ...TaskTemplateFields
    }
  }
  ${TASK_TEMPLATE_FIELDS}
`;

export const getTaskTemplate = gql`
  query getTaskTemplate($templateId: String!) {
    getTaskTemplate(templateId: $templateId) {
      ...TaskTemplateFields
    }
  }
  ${TASK_TEMPLATE_FIELDS}
`;

export const createTaskTemplate = gql`
  mutation createTaskTemplate($input: TaskTemplateCreateInput!) {
    createTaskTemplate(input: $input) {
      ...TaskTemplateFields
    }
  }
  ${TASK_TEMPLATE_FIELDS}
`;

export const deleteTaskTemplate = gql`
  mutation deleteTaskTemplate($templateId: String!) {
    deleteTaskTemplate(templateId: $templateId)
  }
`;

export const importTaskTemplate = gql`
  mutation importTaskTemplate($input: TaskTemplateImportInput!) {
    importTaskTemplate(input: $input) {
      taskId
      name
      description
      taskType
      otherType
      manHours
      startTime
      endTime
      status
      parentTaskId
      presedentTaskId
      budget
    }
  }
`;

const TaskTemplateGraphQL = {
  queries: {
    getTaskTemplates,
    getTaskTemplate,
  },
  mutations: {
    createTaskTemplate,
    deleteTaskTemplate,
    importTaskTemplate,
  },
};

export default TaskTemplateGraphQL;
